<template>
  <div class="pb-1">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />

    <div class="m-4">
      <v-card
        class="p-2"
        elevation="2"
        outlined
      >
        <v-card-title>
          <h5 class="pl-2">
            Feiertage nach Datum Importieren (OpenHolidays API)
          </h5>
        </v-card-title>

        <b-row class="mb-4">
          <b-col cols="1">
            <label class="mt-4 defaultLabel float-right"> Von </label>
          </b-col>
          <b-col cols="2">
            <u-date-picker
              v-model="importPublicHolidaysObject.validFrom"
              label=""
            />
          </b-col>
          <b-col cols="1">
            <label class="mt-4 defaultLabel float-right"> Bis </label>
          </b-col>
          <b-col cols="2">
            <u-date-picker
              v-model="importPublicHolidaysObject.validTo"
              label=""
            />
          </b-col>
          <b-col cols="1" />
          <b-col>
            <v-btn
              :disabled="
                !importPublicHolidaysObject.validFrom ||
                  !importPublicHolidaysObject.validTo
              "
              :loading="isLoadingImport"
              flat
              title="Neuen Feiertagskalender erfassen"
              @click="importResourcecalender"
            >
              <i class="fas fa-upload mr-2" /> Feiertage importieren
            </v-btn>
          </b-col>
        </b-row>
      </v-card>
    </div>

    <div class="m-4">
      <v-card
        class="p-2"
        elevation="2"
        outlined
      >
        <v-card-title>
          <h5 class="pl-2">
            Feiertage mit JSON-Datei Importieren
          </h5>
        </v-card-title>

        <b-row class="mb-4">
          <b-col
            class="mt-4"
            cols="3"
          >
            <input
              ref="importPublicHolidayFile"
              class="ml-4"
              name="importPublicHolidayFile"
              type="file"
            >
          </b-col>
          <b-col cols="4">
            <v-checkbox
              v-model="importOverride"
              color="#e72b37"
            >
              <template v-slot:label>
                <span
                  id="checkboxLabel"
                  class="mt-2"
                >Den bestehenden Feiertagskalender überschreiben</span>
              </template>
            </v-checkbox>
          </b-col>
          <b-col>
            <v-btn
              :loading="isLoadingImportFile"
              class="mt-3"
              flat
              title="Neuen Feiertagskalender erfassen"
              @click="importResourcecalenderFile"
            >
              <i class="fas fa-upload mr-2" /> Feiertage importieren
            </v-btn>
          </b-col>
        </b-row>
      </v-card>
    </div>

    <div class="m-4">
      <v-card
        class="p-2"
        elevation="2"
        outlined
      >
        <v-card-title>
          <h5 class="pl-2">
            Feiertage Exportieren
          </h5>
        </v-card-title>

        <b-row class="mb-4">
          <b-col cols="1">
            <label class="mt-4 defaultLabel float-right"> Von </label>
          </b-col>
          <b-col cols="2">
            <u-date-picker
              v-model="exportPublicHolidaysObject.validFrom"
              label=""
            />
          </b-col>
          <b-col cols="1">
            <label class="mt-4 defaultLabel float-right"> Bis </label>
          </b-col>

          <b-col cols="2">
            <u-date-picker
              v-model="exportPublicHolidaysObject.validTo"
              label=""
            />
          </b-col>
          <b-col cols="1" />
          <b-col>
            <v-btn
              :disabled="
                !exportPublicHolidaysObject.validFrom ||
                  !exportPublicHolidaysObject.validTo
              "
              :loading="isLoadingExport"
              flat
              title="Neuen Feiertagskalender erfassen"
              @click="exportResourcecalender"
            >
              <i class="fas fa-download mr-2" /> Feiertage Exportieren
            </v-btn>
          </b-col>
        </b-row>
      </v-card>
    </div>
  </div>
</template>

<script>
import UDatePicker from "@/components/common/UDatePicker.vue";
import {
  ImportPublicHolidays,
  ExportPublicHolidays,
  ImportPublicHolidaysWithFile,
} from "@/services/minimum.wage.services/resourceCalendar.minimum.wage";

export default {
  components: {
    UDatePicker,
  },
  data() {
    return {
      errorObject: null,
      importPublicHolidaysObject: {
        countryIsoCode: "CH",
        languageIsoCode: "",
        validFrom: "",
        validTo: "",
        subDivisionCode: "",
      },
      exportPublicHolidaysObject: {
        validFrom: "",
        validTo: "",
      },
      importOverride: false,
      isLoadingImport: false,
      isLoadingExport: false,
      isLoadingImportFile: false,
    };
  },
  methods: {
    importResourcecalender() {
      this.isLoadingImport = true;
      ImportPublicHolidays(
        this.importPublicHolidaysObject,
        (respond) => {
          if (respond) {
            this.$emit("resource-calendar-imported");
          }
          this.isLoadingImport = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoadingImport = false;
        },
      );
    },
    importResourcecalenderFile() {
      this.isLoadingImportFile = true;
      const file = this.$refs.importPublicHolidayFile.files[0];

      const reader = new FileReader();

      reader.onload = () => {
        try {
          const jsonObject = JSON.parse(reader.result);
          if (jsonObject) {
            ImportPublicHolidaysWithFile(
              jsonObject,
              this.importOverride,
              (respond) => {
                if (respond) {
                  this.$emit("resource-calendar-imported");
                }
                this.isLoadingImportFile = false;
              },
              (error) => {
                this.errorObject = error;
                this.isLoadingImportFile = false;
              },
            );
          }
        } catch (error) {
          this.errorObject = error;
          this.isLoadingImportFile = false;
        }
      };

      reader.onerror = (error) => {
        this.errorObject = error;
        this.isLoadingImportFile = false;
      };

      reader.readAsText(file);
    },
    exportResourcecalender() {
      this.isLoadingExport = true;
      ExportPublicHolidays(
        this.exportPublicHolidaysObject,
        (respond) => {
          if (respond) {
            const data = respond;
            const json = JSON.stringify(data);
            const blob = new Blob([json], {
              type: "application/json",
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.download =
              new Date().toISOString().replace(/[-T:]/g, "").split(".")[0] +
              "_Feiertage.json";

            a.href = url;
            a.click();
            window.URL.revokeObjectURL(url);
          }
          this.isLoadingExport = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoadingExport = false;
        },
      );
    },
  },
};
</script>

<style scoped>
#checkboxLabel {
  color: #000000;
}
</style>
